import React from 'react';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import BenefitsSection from './BenefitsSection';
import ServicesSection from './ServicesSection';


import Footer from './Footer';
import BlogList from '../Blogs/BlogList';
import StrategicPartners from './StrategicPartners';

const FroniosLanding = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-slate-900 to-black text-white">
      <Navigation />
      <HeroSection />
      <StrategicPartners />
      <BenefitsSection />
      <ServicesSection />
      <BlogList />
      <Footer />
    </div>
  );
};

export default FroniosLanding;